import { Injectable, signal, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ResponsiveService {
  private isMobile = signal<boolean>(this.checkIfMobile());
  public isMobile$ = this.isMobile.asReadonly();

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  private checkIfMobile(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      const width = window.innerWidth;
      return width < 768; // Returns true for mobile, false for anything else
    }
    return false; // Default value when server-side rendering (not mobile)
  }

  updateDeviceType(width: number) {
    const newIsMobile = width < 768;
    if (newIsMobile !== this.isMobile()) {
      this.isMobile.set(newIsMobile);
    }
    // console.log("🚀 ~ ResponsiveService ~ updateDeviceType ~ isMobile:", this.isMobile())

  }
}
